import React from "react";
import styles from "./styles/ServiceCentreProducts.module.css";
import { Reveal } from "../Home/common/Reveal";

import img1 from "../../../images/Micro-Working-Robot-2.jpg";
import img2 from "../../../images/Ceiling-Mounted-Horizontal-Type-Robot-2.jpg";
import img3 from "../../../images/Horizontal-Type-Robot.jpg";
import img4 from "../../../images/Vertical-Type-Robot-1.jpg";

const products = [
  {
    title: "MICRO WORKING ROBOT",
    image: img1,
    description: [
      "Small, high speed, high precision robot with unique 5-links structure. It corresponds to the implementation, transport, assembly and inspection of micro-electronic components.",
      "RP Series: The RP series robots realize space saving with the compact body.",
    ],
  },
  {
    title: "CEILING MOUNTED ROBOT",
    image: img2,
    description: [
      "High speed,high precision,space saving,unique mounting robot.",
      "Capable of wide range applications electric and electronic parts,precision assembly of small parts inspections,high speed transfer,and packing.",
      "RH-FRHR Series: \"Next-generation intelligent functions\", \"Safe, collaborative work applications\", \"FA-IT integration functions\".",
      "With these 3 key features, the FR Series is capable of handling virtually all your automation needs.",
      "RH-FR Series: The F-series robots, RH-FHR-Q series (for iQ platform) and RH-FHR-D series (stand-alone), use the next generation controller that incorporates many intelligent features and significantly improves the performance of the robots.",
    ],
  },
  {
    title: "HORIZONTAL TYPE ROBOT",
    image: img3,
    description: [
      "Capable of wide range applications assembly of small parts,heavy load handling and packing.",
      "Capable of top class high speed high precision operation with dedicated motor and amplifier.It has applicability to diverse works conditions by way Mitsubishi's PLCs and servo motors.",
      "RH-FR Series: \"Next-generation intelligent functions\", \"Safe, collaborative work applications\", \"FA-IT integration functions\".",
      "With these 3 key features, the FR Series is capable of handling virtually all your automation needs.",
      "RH-FR Series: The F-series robots, RH-FHR-Q series (for iQ platform) and RH-FHR-D series (stand-alone), use the next generation controller that incorporates many intelligent features and significantly improves the performance of the robots.",
    ],
  },
  {
    title: "VERTICAL TYPE ROBOT",
    image: img4,
    description: [
      "Capable of top class high speed high precision operation with dedicated motor and amplifier.It has applicability to diverse works on connectivity with Mitsubishi's PLCs and servo motors.",
      "RV-FR Series: \"Next-generation intelligent functions\", \"Safe, collaborative work applications\", \"FA-IT integration functions\".",
      "With these 3 key features, the FR Series is capable of handling virtually all your automation needs.",
      "RV-F Series: The latest series of MELFA robot which equipped with advanced technology and easy-to-use features. iQ Platform type RV-F-Q series and standalone type RV-F-D series.",
    ],
  },
];

export default function ServiceCentreProducts() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {products.map((product, index) => (
            <Reveal key={product.title} delay={index * 100}>
              <article className={styles.product}>
                <div className={styles.imageWrapper}>
                  <img
                    src={product.image}
                    alt={product.title}
                    className={styles.productImage}
                    loading="lazy"
                  />
                </div>
                <h3 className={styles.productTitle}>{product.title}</h3>
                <div className={styles.accent} aria-hidden="true" />
                <ul className={styles.productList}>
                  {product.description.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
